export default {
  SMALL: 'bets.small',
  BIG: 'bets.big',
  ODD: 'bets.odd',
  EVEN: 'bets.even',
  ONE: 'bets.one',
  TWO: 'bets.two',
  THREE: 'bets.three',
  FOUR: 'bets.four',
  FIVE: 'bets.five',
  SIX: 'bets.six',
  LOSE_IF_ANY_TRIPLE: 'sicbo_ui.lose_if_any_triple',
  ANY_TRIPLE: 'sicbo_ui.any_triple',
  ONE_DICE: 'sicbo_ui.one_dice',
  TWO_DICE: 'sicbo_ui.two_dice',
  THREE_DICE: 'sicbo_ui.three_dice',
  EACH_TRIPLE: 'sicbo_ui.each_triple',
  FOUR_TO_TEN: 'sicbo_ui.four_to_ten',
  ELEVEN_TO_SEVENTEEN: 'sicbo_ui.eleven_to_seventeen',
  DOUBLE: 'sicbo_ui.double',
  COMBINATION: 'sicbo_ui.combination',
};
